import { defineExperiment } from '@cian/experiments/ab';

import { AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC, AUD_WEB_BX1122_PIN_UNIFICATION } from '../constants/config/experiments';

export const ExpSinglePinLogic = defineExperiment(AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC, {
  groups: ['A', 'B'] as const,
  default: 'A',
});

export const ExpPinsAndPopupRedesign = defineExperiment(AUD_WEB_BX1122_PIN_UNIFICATION, {
  groups: ['A', 'B'] as const,
  default: 'A',
});
